import { gql, useMutation } from '@apollo/client';

import type {
  UpdateUserSettingsMutation,
  UpdateUserSettingsMutationVariables,
} from './__generated__/useUpdateUserSettings.gql';

const UPDATE_USER_SETTINGS = gql`
  mutation UpdateUserSettings($input: UpdateUserSettingsInput!) {
    updateUserSettings(input: $input) {
      id
      settings {
        lowBalanceThreshold
      }
    }
  }
`;

export const useUpdateUserSettings = () => {
  return useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UPDATE_USER_SETTINGS);
};
